<!-- Page Header Start-->
<div class="page-header" [class.close_icon]="navServices.collapseSidebar">
  <div class="header-wrapper row m-0">
    <app-search></app-search>
    <!-- <div class="header-logo-wrapper col-auto p-0">
      <div class="logo-wrapper">
        <a routerLink="/">
          <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
          <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="" />
        </a>
      </div>
      <div class="toggle-sidebar" (click)="sidebarToggle()">
        <app-feather-icons [icon]="'align-center'" class="status_toggle middle"></app-feather-icons>
      </div>
    </div> -->
    <div class="left-header col-xxl-5 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0">
      <!-- <app-swiper></app-swiper> -->
      <!-- <p class="mb-0">Master page</p> -->
      <div class="ad-left-nav-container">
        <div class="ad-header-logo-wrapper col-auto p-0">
          <div class="ad-logo-wrapper">
            <a routerLink="/">
              <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="Adlogo" />
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="Adlogo" />
            </a>
          </div>
        </div>
        <div class="ad-nav">
          <ul>
            <li>
              <a class="ad-nav-list" [routerLink]="['orders/list']" [ngClass]="{'active': activeLink === 'orders'}"
                (click)="setActiveLink('orders')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z">
                  </path>
                </svg>
                <span>Order list</span>
              </a>
            </li>
            <li>
              <a class="ad-nav-list" [routerLink]="['igm/list']" [ngClass]="{'active': activeLink === 'igm'}"
                (click)="setActiveLink('igm')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z">
                  </path>
                </svg>
                <span>IGM list</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="nav-right col-xxl-7 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 pull-right right-header p-0 ms-auto">
      <ul class="nav-menus">
        <!-- <li class="language-nav" (click)="languageToggle()">
          <app-languages></app-languages>
        </li> -->
        <!-- <li>
          <span class="header-search" (click)="searchToggle()">
            <svg>
              <use href="assets/svg/icon-sprite.svg#search"></use>
            </svg>
          </span>
        </li> -->
        <!-- <li class="onhover-dropdown">
          <app-bookmark></app-bookmark>
        </li> -->
        <li>
          <div class="mode" (click)="layoutToggle()">
            <svg>
              <use href="assets/svg/icon-sprite.svg#moon"></use>
            </svg>
          </div>
        </li>
        <!-- <li class="cart-nav onhover-dropdown">
          <app-cart></app-cart>
        </li> -->
        <!-- <li class="onhover-dropdown">
          <app-notification></app-notification>
        </li> -->
        <li class="profile-nav onhover-dropdown p-0">
          <h3 class="mb-0 adl-buyer-title">ONDC-BUYER</h3>
          <app-my-account></app-my-account>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- mobile menu -->
<div class="ad-mobile">
  <ul>
    <li>
      <a [routerLink]="['orders/list']" [ngClass]="{'active': activeLink === 'orders'}"
        (click)="setActiveLink('orders')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z">
          </path>
        </svg>
        <span>Order list</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['igm/list']" [ngClass]="{'active': activeLink === 'igm'}" (click)="setActiveLink('igm')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z">
          </path>
        </svg>
        <span>IGM list</span>
      </a>
    </li>
  </ul>
</div>
<!-- Page Header Ends -->